import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import TitleBar from "./components/TitleBar";
import styles from "./styles/index.module.css";
import BottomBar from "./components/BottomBar";
import Sidebar from "./components/SideBar";
import Explorer from "./components/Explorer";
import TabsBar from "./components/TabsBar";
import GithubPage from "./pages/GitHubPage";
import ArticlesPage from "./pages/Articles";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ProjectsPage from "./pages/Projects";
import HomePage from "./pages/Home";
import HelperFunctionsPage from "./pages/HelperFunctions";
import WordGame from "./pages/HelperFunctions/Wordle";
import MeterManPage from "./pages/MeterMan";
import MobileNavigation from "./components/MobileNavigation";
import { Navigation } from "./navigation";

/** Selects the Meter Man tab when its direct URL is opened. */
function getInitialNavigation(): Navigation {
	return window.location.pathname.replace(/\/+$/, "").toLowerCase() === "/meterman"
		? "meterMan"
		: "home";
}

export default function App() {
	const [navigation, setNavigation] = useState<Navigation>(getInitialNavigation);
	const [selectedHelperFunction, setSelectedHelperFunction] =
		useState<string>();

	useEffect(() => {
		document.documentElement.setAttribute("data-theme", "");

		function handlePopState(): void {
			setSelectedHelperFunction(undefined);
			setNavigation(getInitialNavigation());
		}

		window.addEventListener("popstate", handlePopState);
		return () => window.removeEventListener("popstate", handlePopState);
	}, []);

	/** Changes tabs and keeps the Meter Man direct URL in sync. */
	function handleNavigation(name: Navigation): void {
		if (name === "helper") {
			setSelectedHelperFunction(undefined);
		}
		const path: string = name === "meterMan" ? "/meterman" : "/";
		if (window.location.pathname !== path) {
			window.history.pushState(null, "", path);
		}
		setNavigation(name);
	}

	return (
		<div className={styles.shell}>
			<TitleBar />
			<MobileNavigation active={navigation} navigateCallback={handleNavigation} />
			<div className={styles.main}>
				<Sidebar
					active={navigation}
					navigateCallback={(s) => handleNavigation(s)}
				/>
				<Explorer
					active={navigation}
					navigateCallback={(s) => handleNavigation(s)}
				/>
				<div className={styles.editor}>
					<TabsBar
						active={navigation}
						navigateCallback={(s) => handleNavigation(s)}
					/>
					<main
						id="main-editor"
						tabIndex={-1}
						aria-label="Editor content"
						className={`${styles.content} ${navigation === "meterMan" ? styles.meterManContent : ""}`}
					>
						{navigation === "home" ? <HomePage /> : null}
						{navigation === "github" ? <GithubPage /> : null}
						{navigation === "articles" ? <ArticlesPage /> : null}
						{navigation === "about" ? <About /> : null}
						{navigation === "contact" ? <Contact /> : null}
						{navigation === "projects" ? <ProjectsPage /> : null}
						{navigation === "meterMan" ? <MeterManPage /> : null}
						{navigation === "helper" && !selectedHelperFunction ? (
							<HelperFunctionsPage
								selectionCallback={setSelectedHelperFunction}
							/>
						) : null}
						{navigation === "helper" &&
						selectedHelperFunction === "wordgame" ? (
							<WordGame />
						) : null}
					</main>
				</div>
			</div>
			<BottomBar />
			<Analytics />
		</div>
	);
}
